import { render, staticRenderFns } from "./CardProducts.vue?vue&type=template&id=4d96eb7f&lang=html&"
import script from "./CardProducts.vue?vue&type=script&lang=js&"
export * from "./CardProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports